import Services from "./service";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Templates from "../../templates";
import NewsPage from "../../organisms/newsPage";
import { Pagination } from "../../molecules/custom";

const News = () => {
  const { dataNews } = Services();
  const dataDummyNews = [
    {
      category: "Design",
      categorySub: "Technology",
      post_title: "How to build up growth team’s performance",
      post_content:
        "Nullam id dolor id nibh ultricies vehicula ut id elit. Praesent commodo cursus magna, vel scelerisque nisl consectetur et.",
      post_image:
        "https://uploads-ssl.webflow.com/5d638efb45d893a76c58d5ca/5d674da2b85ac87fe341a509_nine.jpg",
      slug: "slug1",
    },
    {
      category: "Design",
      categorySub: "Technology",
      post_title: "This is how startups should network",
      post_content:
        "Nullam id dolor id nibh ultricies vehicula ut id elit. Praesent commodo cursus magna, vel scelerisque nisl consectetur et.",
      post_image: "https://via.placeholder.com/1000x600.png?text=IMAGE",
      slug: "slug1",
    },
    {
      category: "Design",
      categorySub: "Technology",
      post_title: "Entrepreneurship Is More Than Being a Founder",
      post_content:
        "Nullam id dolor id nibh ultricies vehicula ut id elit. Praesent commodo cursus magna, vel scelerisque nisl consectetur et.",
      post_image:
        "https://uploads-ssl.webflow.com/5d638efb45d893a76c58d5ca/5d674da21a93c624a8fa4e1e_eight.jpg",
      slug: "slug1",
    },
    {
      category: "Design",
      categorySub: "Technology",
      post_title: "Which Type of Entrepreneur Are You?",
      post_content:
        "Nullam id dolor id nibh ultricies vehicula ut id elit. Praesent commodo cursus magna, vel scelerisque nisl consectetur et.",
      post_image:
        "https://uploads-ssl.webflow.com/5d638efb45d893a76c58d5ca/5d674da2b85ac87fe341a509_nine.jpg",
      slug: "slug1",
    },
    {
      category: "Design",
      categorySub: "Technology",
      post_title: "9 Things We Learned By Starting A Business",
      post_content:
        "Nullam id dolor id nibh ultricies vehicula ut id elit. Praesent commodo cursus magna, vel scelerisque nisl consectetur et.",
      post_image: "https://via.placeholder.com/1000x600.png?text=IMAGE",
      slug: "slug1",
    },
    {
      category: "Design",
      categorySub: "Technology",
      post_title: "The day I knew it was time to move on from my first startup",
      post_content:
        "Nullam id dolor id nibh ultricies vehicula ut id elit. Praesent commodo cursus magna, vel scelerisque nisl consectetur et.",
      post_image:
        "https://uploads-ssl.webflow.com/5d638efb45d893a76c58d5ca/5d674da21a93c624a8fa4e1e_eight.jpg",
      slug: "slug1",
    },
    {
      category: "Design",
      categorySub: "Technology",
      post_title: "How to build up growth team’s performance",
      post_content:
        "Nullam id dolor id nibh ultricies vehicula ut id elit. Praesent commodo cursus magna, vel scelerisque nisl consectetur et.",
      post_image:
        "https://uploads-ssl.webflow.com/5d638efb45d893a76c58d5ca/5d674da2b85ac87fe341a509_nine.jpg",
      slug: "slug1",
    },
    {
      category: "Design",
      categorySub: "Technology",
      post_title: "This is how startups should network",
      post_content:
        "Nullam id dolor id nibh ultricies vehicula ut id elit. Praesent commodo cursus magna, vel scelerisque nisl consectetur et.",
      post_image: "https://via.placeholder.com/1000x600.png?text=IMAGE",
      slug: "slug1",
    },
    {
      category: "Design",
      categorySub: "Technology",
      post_title: "Entrepreneurship Is More Than Being a Founder",
      post_content:
        "Nullam id dolor id nibh ultricies vehicula ut id elit. Praesent commodo cursus magna, vel scelerisque nisl consectetur et.",
      post_image:
        "https://uploads-ssl.webflow.com/5d638efb45d893a76c58d5ca/5d674da21a93c624a8fa4e1e_eight.jpg",
      slug: "slug1",
    },
    {
      category: "Design",
      categorySub: "Technology",
      post_title: "Which Type of Entrepreneur Are You?",
      post_content:
        "Nullam id dolor id nibh ultricies vehicula ut id elit. Praesent commodo cursus magna, vel scelerisque nisl consectetur et.",
      post_image:
        "https://uploads-ssl.webflow.com/5d638efb45d893a76c58d5ca/5d674da2b85ac87fe341a509_nine.jpg",
      slug: "slug1",
    },
    {
      category: "Design",
      categorySub: "Technology",
      post_title: "9 Things We Learned By Starting A Business",
      post_content:
        "Nullam id dolor id nibh ultricies vehicula ut id elit. Praesent commodo cursus magna, vel scelerisque nisl consectetur et.",
      post_image: "https://via.placeholder.com/1000x600.png?text=IMAGE",
      slug: "slug1",
    },
    {
      category: "Design",
      categorySub: "Technology",
      post_title: "The day I knew it was time to move on from my first startup",
      post_content:
        "Nullam id dolor id nibh ultricies vehicula ut id elit. Praesent commodo cursus magna, vel scelerisque nisl consectetur et.",
      post_image:
        "https://uploads-ssl.webflow.com/5d638efb45d893a76c58d5ca/5d674da21a93c624a8fa4e1e_eight.jpg",
      slug: "slug1",
    },
    {
      category: "Design",
      categorySub: "Technology",
      post_title: "How to build up growth team’s performance",
      post_content:
        "Nullam id dolor id nibh ultricies vehicula ut id elit. Praesent commodo cursus magna, vel scelerisque nisl consectetur et.",
      post_image:
        "https://uploads-ssl.webflow.com/5d638efb45d893a76c58d5ca/5d674da2b85ac87fe341a509_nine.jpg",
      slug: "slug1",
    },
    {
      category: "Design",
      categorySub: "Technology",
      post_title: "This is how startups should network",
      post_content:
        "Nullam id dolor id nibh ultricies vehicula ut id elit. Praesent commodo cursus magna, vel scelerisque nisl consectetur et.",
      post_image: "https://via.placeholder.com/1000x600.png?text=IMAGE",
      slug: "slug1",
    },
    {
      category: "Design",
      categorySub: "Technology",
      post_title: "Entrepreneurship Is More Than Being a Founder",
      post_content:
        "Nullam id dolor id nibh ultricies vehicula ut id elit. Praesent commodo cursus magna, vel scelerisque nisl consectetur et.",
      post_image:
        "https://uploads-ssl.webflow.com/5d638efb45d893a76c58d5ca/5d674da21a93c624a8fa4e1e_eight.jpg",
      slug: "slug1",
    },
    {
      category: "Design",
      categorySub: "Technology",
      post_title: "Which Type of Entrepreneur Are You?",
      post_content:
        "Nullam id dolor id nibh ultricies vehicula ut id elit. Praesent commodo cursus magna, vel scelerisque nisl consectetur et.",
      post_image:
        "https://uploads-ssl.webflow.com/5d638efb45d893a76c58d5ca/5d674da2b85ac87fe341a509_nine.jpg",
      slug: "slug1",
    },
    {
      category: "Design",
      categorySub: "Technology",
      post_title: "9 Things We Learned By Starting A Business",
      post_content:
        "Nullam id dolor id nibh ultricies vehicula ut id elit. Praesent commodo cursus magna, vel scelerisque nisl consectetur et.",
      post_image: "https://via.placeholder.com/1000x600.png?text=IMAGE",
      slug: "slug1",
    },
    {
      category: "Design",
      categorySub: "Technology",
      post_title: "The day I knew it was time to move on from my first startup",
      post_content:
        "Nullam id dolor id nibh ultricies vehicula ut id elit. Praesent commodo cursus magna, vel scelerisque nisl consectetur et.",
      post_image:
        "https://uploads-ssl.webflow.com/5d638efb45d893a76c58d5ca/5d674da21a93c624a8fa4e1e_eight.jpg",
      slug: "slug1",
    },
  ];
  const { pathname } = useLocation();
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(10);
  const [isHovering, setIsHovering] = useState(-1);
  useEffect(() => {
    setLoading(false);
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const totalPageCount = Math.ceil(dataDummyNews.length / 10);
  const currentPosts = dataNews.slice(indexOfFirstPost, indexOfLastPost);
  console.log(totalPageCount);

  const paginate = (pageNumbers) => setCurrentPage(pageNumbers);
  return (
    <Templates loading={loading}>
      <NewsPage
        dataNews={currentPosts}
        totalPageCount={totalPageCount}
        isHovering={isHovering}
        setIsHovering={setIsHovering}
      />
      <Pagination
        postsPerPage={postsPerPage}
        totalPosts={dataNews.length}
        paginate={paginate}
      />
    </Templates>
  );
};

export default News;
